<template>
  <div>
    <lite
      v-if="! isWordpressPlugin"
      :faq-uuid="faqUuid"
      :lite-slug="liteSlug"
      :edit-url="editUrl"
      :register-url="registerUrl"
      :loader-script-url="loaderScriptUrl"
      @snack="snack"
    />

    <wordpress-plugin
      v-else
      :faq-uuid="faqUuid"
      :lite-slug="liteSlug"
      @snack="snack"
    />

    <v-snackbar
      v-model="snackbar.show"
      top
      :color="snackbar.color"
    >
      {{ snackbar.text }}

      <template #action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="snackbar.show = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Layout from '@/lite/components/TheLayout';
import Lite from '@/lite/components/Lite';
import WordpressPlugin from '@/lite/components/WordpressPlugin';

export default {
  components: {
    Lite,
    WordpressPlugin
  },

  layout: (h, page) => h(Layout, {
    props: {
      theme: 'light',
      registerUrl: page.data.props.registerUrl
    }
  }, [page]),

  props: {
    liteSlug: {
      type: String,
      required: true
    },
    faqUuid: {
      type: String,
      required: true
    },
    editUrl: {
      type: String,
      required: true
    },
    registerUrl: {
      type: String,
      required: true
    },
    loaderScriptUrl: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      isWordpressPlugin: null,

      snackbar: {
        show: false,
        color: '',
        text: ''
      },
    }
  },

  created() {
    const params = new URLSearchParams(window.location.search);
    this.isWordpressPlugin = params.get('wp-plugin') === 'true';
  },

  methods: {
    snack(color, text) {
      this.snackbar.show = true;
      this.snackbar.color = color;
      this.snackbar.text = text;
    },
  }
}
</script>